import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tp-mini" }
const _hoisted_2 = {
  key: 0,
  class: "tp-mini__empty"
}
const _hoisted_3 = {
  key: 1,
  class: "tp-mini__grid"
}
const _hoisted_4 = ["disabled", "title", "onClick"]
const _hoisted_5 = { class: "tp-mini__cell-head" }
const _hoisted_6 = { class: "tp-mini__name" }
const _hoisted_7 = { class: "tp-mini__meta" }
const _hoisted_8 = {
  key: 0,
  class: "tp-mini__required"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "tp-mini__broken"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.layout || _ctx.layout.rows.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.emptyText), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.rows, (row, rowIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: rowIndex,
              class: "tp-mini__row"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cells, (cell, cellIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${rowIndex}-${cellIndex}`,
                  class: "tp-mini__col",
                  style: _normalizeStyle({ width: `${_ctx.widthPercents(row.widths)[cellIndex]}%` })
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tp-mini__cell", _ctx.cellClass(cell)]),
                    disabled: !_ctx.isSelectable(cell),
                    title: _ctx.cellTitle(cell),
                    onClick: ($event: any) => (_ctx.onCellClick(cell))
                  }, [
                    _createElementVNode("span", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markersOf(cell), (marker) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: marker.symbol,
                          class: _normalizeClass(["tp-mini__symbol", {
                  'tp-mini__symbol--reference': marker.mode === 'reference',
                  'tp-mini__symbol--broken': marker.broken,
                }])
                        }, _toDisplayString(marker.symbol), 3))
                      }), 128)),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(cell.name || "（名称未設定）"), 1)
                    ]),
                    _createElementVNode("span", _hoisted_7, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.cellTypeLabels[cell.type]), 1),
                      (cell.required)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "必須"))
                        : _createCommentVNode("", true),
                      (!cell.visible)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Excel非出力"))
                        : _createCommentVNode("", true),
                      (_ctx.hasBroken(cell))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "要確認"))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_4)
                ], 4))
              }), 128))
            ]))
          }), 128))
        ]))
  ]))
}